import { createTheme, ThemeOptions, ThemeProvider } from '@mui/material';
import './App.scss';
import Context from './Context';
import { BrowserRouter as Router, Routes, Route}
    from 'react-router-dom';
import Home from './pages/Home';
import Gachapon from './pages/Gachapon';
import Prizes from './pages/Prizes';
import PrizeWalletStatus from './pages/PrizeWalletStatus';
import BearerCheck from './components/BearerCheck';

function App() {

  const themeOptions: ThemeOptions = {
    palette: {
      primary: {
        main: '#fe38a2',
      },
      secondary: {
        main: '#9a37ff',
      },
      warning: {
        main: '#ff8337',
      },
      success: {
        main: '#12FFA9',
      },
      info: {
        main: '#2b97f1',
      },
    },
    typography: {
      fontFamily: 'Nunito'
    }
  };

  const theme = createTheme(themeOptions);

  return (
    <ThemeProvider theme={theme}>
      <Context>
      <Router>
        <Routes>
        
        <Route  path='/' element={<div className="App"><Gachapon/></div>} />
        <Route path='prizes' element={<div className="App"><Prizes/></div>} />
        <Route path='prizes/' element={<div className="App"><Prizes/></div>} />
        <Route path='admin' element={<BearerCheck> <PrizeWalletStatus/> </BearerCheck>} />
        </Routes>
        </Router>
      </Context>
    </ThemeProvider>
  );
}

export default App;
